import { useBrand } from '@contexts/index'
import { upperCaseFirst } from '@utils/helpers/stringHelpers'

const getPrivacyLink = (brand: string) => {
  switch (brand) {
    case 'lexus':
      return 'https://www.lexus.co.uk/customer-data/privacy-policy'
    case 'kinto':
      return 'https://www.kinto-uk.com/privacy-notice/'
    case 'toyota':
    default:
      return 'https://www.toyota.co.uk/footer/privacy-policy'
  }
}

const getPrivacyEmail = (brand: string) => {
  switch (brand) {
    case 'lexus':
      return 'privacy@ld.lexus.co.uk'
    case 'toyota':
    default:
      return 'privacy@tgb.toyota.co.uk'
  }
}

const MarketingTerms = () => {
  const brand = useBrand()

  const privacyLink = getPrivacyLink(brand)
  const privacyEmail = getPrivacyEmail(brand)

  return (
    <div className="mt-8">
      <p>
        Be assured that {upperCaseFirst(brand)} will only share your personal
        information with companies that are an integral part of fulfilling the
        services we deliver. If you would like to find out more about how we
        process your data please visit our{' '}
        <a
          className="underline"
          href={privacyLink}
          target={'_blank'}
          rel={'noopener noreferrer'}
          data-gt-name="ctaevent"
          data-gt-action="terms-click-link"
          data-gt-label={privacyLink}
        >
          privacy notice
        </a>{' '}
        for details.
      </p>
      <p className="mt-4">
        By unsubscribing, you will be removed from our marketing emails.
        However, we may still contact you about important information where
        consent isn&apos;t required. If you&apos;d like to stop receiving all
        communications, please email us at{' '}
        <a
          className="underline"
          href={`mailto:${privacyEmail}`}
          data-gt-name="ctaevent"
          data-gt-action="terms-click-link"
          data-gt-label={privacyEmail}
        >
          {privacyEmail}
        </a>{' '}
        and we&apos;ll add you to our full suppression list.
      </p>
    </div>
  )
}

export default MarketingTerms
